const initialState = {
    items: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'SET_FEATURES':
            let items = [];

            if (action.payload.features) {
                items = action.payload.features;
            }

            return {
                ...state,
                items: items,
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/core/admin/store/reducers/features.js